// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image-space1-gU9Eo {
	margin-bottom: 6px !important;
}

.Image-space2-PNaXr {
	margin-bottom: 12px !important;
}

.Image-space3-UlPMa {
	margin-bottom: 18px !important;
}

.Image-space4-WWZ8G {
	margin-bottom: 24px !important;
}

.Image-space5-p5Ear {
	margin-bottom: 30px !important;
}

.Image-space6-R7nNR {
	margin-bottom: 36px !important;
}

.Image-space7-b8FFH {
	margin-bottom: 42px !important;
}

.Image-spaceTop8-MiWWF {
	margin-bottom: 48px !important;
}

.Image-spaceTop1-ntODI {
	margin-top: 6px !important;
}

.Image-spaceTop2-kYRQd {
	margin-top: 12px !important;
}

.Image-spaceTop3-pOZcY {
	margin-top: 18px !important;
}

.Image-spaceTop4-OHTwv {
	margin-top: 24px !important;
}

.Image-spaceTop5-dRnSd {
	margin-top: 30px !important;
}

.Image-spaceTop6-u4uB4 {
	margin-top: 36px !important;
}

.Image-spaceTop7-A2HWj {
	margin-top: 42px !important;
}

.Image-spaceTop8-MiWWF {
	margin-top: 48px !important;
}

.Image-noMargin-celSL {
	margin: 0px !important;
}

.Image-padding1-gNQLq {
	padding-bottom: 6px !important;
}

.Image-padding2-y4b8L {
	padding-bottom: 12px !important;
}

.Image-padding3-Dwt8y {
	padding-bottom: 18px !important;
}

.Image-padding4-frSWh {
	padding-bottom: 24px !important;
}

.Image-padding5-aSmtW {
	padding-bottom: 30px !important;
}

.Image-padding6-mksMr {
	padding-bottom: 36px !important;
}

.Image-padding7-b1Xx6 {
	padding-bottom: 42px !important;
}

.Image-paddingTop1-WtNow {
	padding-top: 6px !important;
}

.Image-paddingTop2-S2T2e {
	padding-top: 12px !important;
}

.Image-paddingTop3-sFpAd {
	padding-top: 18px !important;
}

.Image-paddingTop4-LGxNc {
	padding-top: 24px !important;
}

.Image-paddingTop5-UklNG {
	padding-top: 30px !important;
}

.Image-paddingTop6-yVVvJ {
	padding-top: 36px !important;
}

.Image-paddingTop7-p647z {
	padding-top: 42px !important;
}

.Image-noPadding-dtMwy {
	padding: 0px !important;
}

.Image-textBold-SKD2T {
	font-weight: 500 !important;
}

.Image-textBolder-WbUZK {
	font-weight: 700 !important;
}

.Image-textNormal-gtsyF {
	font-weight: normal !important;
}

.Image-spaceBottom20-m1U6J {
	margin-bottom: 20px;
}

.Image-spaceBottom10-ALbrb {
	margin-bottom: 10px;
}

.Image-marginNone-UZhzb {
	margin: 0;
}

.Image-spaceBottom15-SAs17 {
	margin-bottom: 15px;
}

.Image-marginTopNone-qdqLh {
	margin-top: 0;
}

.Image-spaceTop11-lFBWq {
	margin-top: 11px;
}

.Image-spaceTop21-XYLpu {
	margin-top: 21px;
}

.Image-spaceTop20-ScEye {
	margin-top: 20px;
}

.Image-spaceTop10-eG52N {
	margin-top: 10px;
}

/*New Design Text Colors */

.Image-textDarkBlue-eHLPG {
	color: rgb(20, 39, 94) !important;
}

.Image-textLightBlue-Bfkir {
	color: rgb(57, 87, 106) !important;
}

.Image-textLightSandleGreen-EjP9s {
	color: rgb(76, 86, 41) !important;
}

.Image-textLightBrown-b_pSB {
	color: rgb(115, 79, 33) !important;
}

.Image-textMediumMaroon-d0Dj5 {
	color: rgb(87, 37, 51) !important;
}

.Image-textBrown-ne9w5 {
	color: rgb(160, 47, 24) !important;
}

.Image-textMaroon-CgEhB {
	color: rgb(155, 49, 67) !important;
}

.Image-textDarkBrown-lKo3d {
	color: rgb(83, 18, 16) !important;
}

.Image-textMediumBrown-TOAVk {
	color: rgb(142, 28, 10) !important;
}

.Image-textSkyBlue-X6ySk {
	color: rgb(37, 117, 141) !important;
}

.Image-textGray-dDXGI {
	color: rgb(77, 65, 51) !important;
}

.Image-commonHeaderAdmin-GZ9fI {
	position: fixed !important;
}

.Image-adminLayout-Ne1qh {
	padding-top: 64px !important;
}

.Image-box-OaoW0 h2 {
	font-size: 21px;
	font-weight: 600;
}

.Image-exportLink-GbY1c {
	margin-bottom: -29px;
}

.Image-blockCenter-WbicI {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Image-panelHeader-cW8Vo {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Image-currencyselect-ZN5th {
	width: 100%;
	margin-right: 0px;
}

.Image-panelHeader-cW8Vo {
	overflow: hidden;
	position: relative;
}

.Image-mar0-jsa15 {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Image-blockCenter-WbicI {
		padding: 0px;
	}

	.Image-panelHeader-cW8Vo {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Image-sideAdminPageWrapper-XXKac {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Image-panelHeader-cW8Vo {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Image-table-WJysx {
	display: table;
}

.Image-tableRow-LR5Et {
	display: table-row;
}

.Image-tableCell-s_wRz {
	display: table-cell;
	float: none;
}

.Image-formGroup-Q5Z2a {
	margin-bottom: 6px;
}

.Image-select-lSFYK {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Image-noMargin-celSL {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Image-exportLink-GbY1c {
	padding-top: 10px;
	padding-right: 10px;
}

.Image-labelTextNew-zF6kL {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-displayInline-eKYgI {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Image-btnUPdate-bluyD {
	display: inline-block;
}

.Image-btnModalDelete-nPtjc {
	display: inline-block;
	margin-left: 15px;
}

.Image-radioBtn-QcII4 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Image-backgroundImg-LWMDP {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Image-btnUPdate-bluyD {
		display: block;
		margin-bottom: 12px;
	}

	.Image-btnModalDelete-nPtjc {
		display: block;
		margin-left: 0px;
	}

	.Image-btnWidth-fTBMH {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Image-bannerImageBg-Dukju {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Image-bannerDelete-tnlSR {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Image-modalRoot-IfOQZ {
	padding: 32px;
}

.Image-modalBorderBottom-Rze3v {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Image-logInModalBody-vFYa1 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Image-exportSection-yGu62 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Image-exportSectionGridSub-CDC6N {
	grid-template-columns: 50% 49% !important;
}

.Image-exportText-iSXV4 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Image-exportLinkImg-HNdM2 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Image-vtrMiddle-NFIBr {
	vertical-align: middle;
}

.Image-exportImg-UktaM {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image-profileViewlabel-jZ5sV {
	display: inline-block;
	width: 38%
}

.Image-profileViewMainContent-RrzAk {
	display: inline-block;
	width: 62%;
}

.Image-profileViewMain-qkOYX {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Image-profileViewInner-A4nRj {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Image-profileImageSection-XBI5u {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Image-lastviewInner-binq4 {
	padding: 10px;
}

.Image-whyHostHoriLine-e9jp7 {
	margin: 30px 0;
}

.Image-tableGrid-kAC9j {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Image-headingContent-zNXn0 {
	font-size: 18px;
	font-weight: 500;
}

.Image-refundTextColor-nRddJ {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Image-dividerLine-oxYmb {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Image-smallContent-MM5g6 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Image-sideAdminPageWrapper-XXKac {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Image-sideAdminPageWrapper-XXKac {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Image-exportSection-yGu62 {
		grid-template-columns: 100%;
	}

	.Image-exportSectionGridSub-CDC6N {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Image-profileViewlabel-jZ5sV {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image-profileViewMainContent-RrzAk {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Image-ChangeToUpperCase-WeL7E {
	text-transform: uppercase
}

.Image-noBorder-hCUZV {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Image-siteAdminHeading-r2IR9 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-siteAdminSubHeading-gpxuH {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-adminFormDivider-W6eWR {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image-space1-gU9Eo`,
	"space2": `Image-space2-PNaXr`,
	"space3": `Image-space3-UlPMa`,
	"space4": `Image-space4-WWZ8G`,
	"space5": `Image-space5-p5Ear`,
	"space6": `Image-space6-R7nNR`,
	"space7": `Image-space7-b8FFH`,
	"spaceTop8": `Image-spaceTop8-MiWWF`,
	"spaceTop1": `Image-spaceTop1-ntODI`,
	"spaceTop2": `Image-spaceTop2-kYRQd`,
	"spaceTop3": `Image-spaceTop3-pOZcY`,
	"spaceTop4": `Image-spaceTop4-OHTwv`,
	"spaceTop5": `Image-spaceTop5-dRnSd`,
	"spaceTop6": `Image-spaceTop6-u4uB4`,
	"spaceTop7": `Image-spaceTop7-A2HWj`,
	"noMargin": `Image-noMargin-celSL`,
	"padding1": `Image-padding1-gNQLq`,
	"padding2": `Image-padding2-y4b8L`,
	"padding3": `Image-padding3-Dwt8y`,
	"padding4": `Image-padding4-frSWh`,
	"padding5": `Image-padding5-aSmtW`,
	"padding6": `Image-padding6-mksMr`,
	"padding7": `Image-padding7-b1Xx6`,
	"paddingTop1": `Image-paddingTop1-WtNow`,
	"paddingTop2": `Image-paddingTop2-S2T2e`,
	"paddingTop3": `Image-paddingTop3-sFpAd`,
	"paddingTop4": `Image-paddingTop4-LGxNc`,
	"paddingTop5": `Image-paddingTop5-UklNG`,
	"paddingTop6": `Image-paddingTop6-yVVvJ`,
	"paddingTop7": `Image-paddingTop7-p647z`,
	"noPadding": `Image-noPadding-dtMwy`,
	"textBold": `Image-textBold-SKD2T`,
	"textBolder": `Image-textBolder-WbUZK`,
	"textNormal": `Image-textNormal-gtsyF`,
	"spaceBottom20": `Image-spaceBottom20-m1U6J`,
	"spaceBottom10": `Image-spaceBottom10-ALbrb`,
	"marginNone": `Image-marginNone-UZhzb`,
	"spaceBottom15": `Image-spaceBottom15-SAs17`,
	"marginTopNone": `Image-marginTopNone-qdqLh`,
	"spaceTop11": `Image-spaceTop11-lFBWq`,
	"spaceTop21": `Image-spaceTop21-XYLpu`,
	"spaceTop20": `Image-spaceTop20-ScEye`,
	"spaceTop10": `Image-spaceTop10-eG52N`,
	"textDarkBlue": `Image-textDarkBlue-eHLPG`,
	"textLightBlue": `Image-textLightBlue-Bfkir`,
	"textLightSandleGreen": `Image-textLightSandleGreen-EjP9s`,
	"textLightBrown": `Image-textLightBrown-b_pSB`,
	"textMediumMaroon": `Image-textMediumMaroon-d0Dj5`,
	"textBrown": `Image-textBrown-ne9w5`,
	"textMaroon": `Image-textMaroon-CgEhB`,
	"textDarkBrown": `Image-textDarkBrown-lKo3d`,
	"textMediumBrown": `Image-textMediumBrown-TOAVk`,
	"textSkyBlue": `Image-textSkyBlue-X6ySk`,
	"textGray": `Image-textGray-dDXGI`,
	"commonHeaderAdmin": `Image-commonHeaderAdmin-GZ9fI`,
	"adminLayout": `Image-adminLayout-Ne1qh`,
	"box": `Image-box-OaoW0`,
	"exportLink": `Image-exportLink-GbY1c`,
	"blockCenter": `Image-blockCenter-WbicI`,
	"panelHeader": `Image-panelHeader-cW8Vo`,
	"currencyselect": `Image-currencyselect-ZN5th`,
	"mar0": `Image-mar0-jsa15`,
	"sideAdminPageWrapper": `Image-sideAdminPageWrapper-XXKac`,
	"table": `Image-table-WJysx`,
	"tableRow": `Image-tableRow-LR5Et`,
	"tableCell": `Image-tableCell-s_wRz`,
	"formGroup": `Image-formGroup-Q5Z2a`,
	"select": `Image-select-lSFYK`,
	"labelTextNew": `Image-labelTextNew-zF6kL`,
	"displayInline": `Image-displayInline-eKYgI`,
	"btnUPdate": `Image-btnUPdate-bluyD`,
	"btnModalDelete": `Image-btnModalDelete-nPtjc`,
	"radioBtn": `Image-radioBtn-QcII4`,
	"backgroundImg": `Image-backgroundImg-LWMDP`,
	"btnWidth": `Image-btnWidth-fTBMH`,
	"bannerImageBg": `Image-bannerImageBg-Dukju`,
	"bannerDelete": `Image-bannerDelete-tnlSR`,
	"modalRoot": `Image-modalRoot-IfOQZ`,
	"modalBorderBottom": `Image-modalBorderBottom-Rze3v`,
	"logInModalBody": `Image-logInModalBody-vFYa1`,
	"exportSection": `Image-exportSection-yGu62`,
	"exportSectionGridSub": `Image-exportSectionGridSub-CDC6N`,
	"exportText": `Image-exportText-iSXV4`,
	"exportLinkImg": `Image-exportLinkImg-HNdM2`,
	"vtrMiddle": `Image-vtrMiddle-NFIBr`,
	"exportImg": `Image-exportImg-UktaM`,
	"profileViewlabel": `Image-profileViewlabel-jZ5sV`,
	"profileViewMainContent": `Image-profileViewMainContent-RrzAk`,
	"profileViewMain": `Image-profileViewMain-qkOYX`,
	"profileViewInner": `Image-profileViewInner-A4nRj`,
	"profileImageSection": `Image-profileImageSection-XBI5u`,
	"lastviewInner": `Image-lastviewInner-binq4`,
	"whyHostHoriLine": `Image-whyHostHoriLine-e9jp7`,
	"tableGrid": `Image-tableGrid-kAC9j`,
	"headingContent": `Image-headingContent-zNXn0`,
	"refundTextColor": `Image-refundTextColor-nRddJ`,
	"dividerLine": `Image-dividerLine-oxYmb`,
	"smallContent": `Image-smallContent-MM5g6`,
	"ChangeToUpperCase": `Image-ChangeToUpperCase-WeL7E`,
	"noBorder": `Image-noBorder-hCUZV`,
	"siteAdminHeading": `Image-siteAdminHeading-r2IR9`,
	"siteAdminSubHeading": `Image-siteAdminSubHeading-gpxuH`,
	"adminFormDivider": `Image-adminFormDivider-W6eWR`
};
module.exports = ___CSS_LOADER_EXPORT___;
